import { render, staticRenderFns } from "./liveCreateComponent.vue?vue&type=template&id=4806f817&"
import script from "./liveCreateComponent.vue?vue&type=script&lang=ts&"
export * from "./liveCreateComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports